import { useAppSelector } from '@user/store/hooks'
import { selectSalesPersonFilterEnabled } from '@user/store/tenantFeatures'

export function useSalesPersonFilterEnabled() {
  return useAppSelector(selectSalesPersonFilterEnabled)
}
